import { createReducer, createSelector } from 'redux-starter-kit';
import {
  putCurrencyReport, putCurrencyReports, putTaxReportRegion, putTaxReportRegions,
} from './financialActions';

/**
 * Select data for currency reports and the tax report (1 report at a time)
 */
export const selectCurrencyReports = createSelector(['via.domain.financial'], map => (map ? Object.values(map) : null));

/**
 */
const initialFinancialState = {
};

export default createReducer(initialFinancialState, {
  [putCurrencyReport]: (state, action) => {
    const report = action.payload;
    return {
      ...state,
      [report.currency]: report,
    };
  },

  // Replaces all the outcomes in the state.
  [putCurrencyReports]: (state, action) => {
    const reports = action.payload;

    return reports.reduce((newState, report) => {
      newState[report.currency] = report; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialFinancialState });
  },

  [putTaxReportRegion]: (state, action) => {
    const report = action.payload;
    return {
      ...state,
      [report.region + report.currency]: report,
    };
  },

  // Replaces all the outcomes in the state.
  [putTaxReportRegions]: (state, action) => {
    const reports = action.payload;

    return reports.map((newState, report) => {
      newState[report.region + report.currency] = report; // eslint-disable-line no-param-reassign
      return newState;
    }, { ...initialFinancialState });
  },
});
